import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import PlatformLayout from "../components/layout/Layout";
import Layout from "../Layout";
import LoginPage from "../pages/auth/LoginPage";
import ErrorsPage from "../pages/dashboard/ErrorsPage";
import OverviewPage from "../pages/dashboard/OverviewPage";
import TrackingDetailsPage from "../pages/dashboard/TrackingDetailsPage";
import SessionDetailPage from "../pages/logs/SessionDetailPage";
import SessionsPage from "../pages/logs/SessionsPage";
import UserManagementPage from "../pages/admin/UserManagementPage";
import NotFoundPage from "../pages/NotFoundPage";
import ProtectedRoute from "./ProtectedRoute";
import PublicOnlyRoute from "./PublicOnlyRoute";

const ShellRoute = () => (
  <PlatformLayout>
    <Outlet />
  </PlatformLayout>
);

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/chat" replace />} />

    {/* Public chat — no login required */}
    <Route path="/chat" element={<Layout />} />

    {/* Admin login only */}
    <Route element={<PublicOnlyRoute />}>
      <Route path="/login" element={<LoginPage />} />
    </Route>

    {/* Admin monitor routes */}
    <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
      <Route element={<ShellRoute />}>
        <Route path="/dashboard" element={<OverviewPage />} />
        <Route path="/tracking-details" element={<TrackingDetailsPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/sessions/:sessionId" element={<SessionDetailPage />} />
        <Route path="/errors" element={<ErrorsPage />} />
        <Route path="/admin/users" element={<UserManagementPage />} />
      </Route>
    </Route>

    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRouter;
